import app, { firebaseAuth } from "firebaseConfig";
import { signInWithPhoneNumber, RecaptchaVerifier } from "firebase/auth";
import { useEffect, useState } from "react";
import { authService } from "services/authServices";
import { useDispatch } from "react-redux";
import { login } from "store/apps/auth";
import { redirect, useNavigate } from "react-router-dom";

const { REACT_APP_IS_UAT } = process.env;

// import { redirect } from "react-router-dom";

export default function useLoginByPhone() {
  const [phone, setPhone] = useState<string>("");
  const [code, setCode] = useState<string>("");

  const [isShowPopUp, setIsShowPopUp] = useState<boolean>(false);

  const [confirmInfo, setConfirmInfo] = useState<any>(null);

  const [isRecaptchaVerifierLoading, setIsRecaptchaVerifierLoading] = useState<boolean>(false);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const _onPhoneLogin = async (e: any) => {
    try {
      e.preventDefault();

      if (REACT_APP_IS_UAT === "TRUE") {
        const user = await authService.signInWithPhone("1234", Number(phone));

        dispatch(login(user));

        navigate("/");

        return;
      }

      setIsRecaptchaVerifierLoading(true);

      const appVerifier = new RecaptchaVerifier(firebaseAuth, "recaptcha-container");

      const confirm = await signInWithPhoneNumber(firebaseAuth, `+852${phone}`, appVerifier);

      setIsRecaptchaVerifierLoading(false);

      setIsShowPopUp(true);
      setConfirmInfo(confirm);
    } catch (error) {
      setIsRecaptchaVerifierLoading(false);
      setIsShowPopUp(false);
    }
  };

  useEffect(() => {
    if (code.length !== 6) return;

    (async function () {
      const result = await confirmInfo.confirm(code);

      const user = await authService.signInWithPhone(result.user.uid, Number(phone));

      dispatch(login(user));

      navigate("/");
    })();
  }, [code]);

  return { phone, isShowPopUp, code, isRecaptchaVerifierLoading, setPhone, setIsShowPopUp, setCode, _onPhoneLogin };
}
